<template>
  <div class="addCompanyTem">
    <p v-if="popStatu=='add'" class="titleP">{{ $t('adminView.add') }} {{ $t('company.childCompany') }}</p>
    <p v-if="popStatu=='edit'" class="titleP">{{ $t('adminView.Edit') }} {{ $t('adminView.CompanyInfo') }}</p>
    <p v-if="popStatu=='info'" class="titleP">{{ $t('adminView.CompanyInfo') }}</p>
    <el-form ref="dialogForm" :inline="false" class="dialogForm" :model="popObj" label-position="left" label-width="auto" :rules="addCompanyRules">
      <el-form-item v-if="userCompanyId!=popObj.id" :label="$t('company.Parentcompany')" prop="mm">
        <el-input v-model="popObj.companyParentName" :disabled="true" />
      </el-form-item>
      <el-form-item :label="$t('company.Companyname')" prop="companyName">
        <el-input v-model="popObj.companyName" :disabled="popStatu=='info'" maxlength="50" @input="change($event)" />
      </el-form-item>
      <el-form-item :label="$t('company.Companyaddress')" prop="companyAddr">
        <el-input v-model="popObj.companyAddr" :disabled="popStatu=='info'" maxlength="80" @input="change($event)" />
      </el-form-item>
      <el-form-item :label="$t('company.Companywebsite')" prop="companyUrl">
        <el-input v-model.trim="popObj.companyUrl" :disabled="popStatu=='info'" maxlength="50" @input="change($event)" />
      </el-form-item>
      <el-form-item v-if="popStatu=='info'" :label="$t('company.Numberofbranches')" prop="NumBranches">
        <el-input v-model="popObj.childListSize" :disabled="popStatu=='info'" @input="change($event)" />
      </el-form-item>
    </el-form>
    <div v-if="popStatu!='info'" slot="footer" class="dialog-footer">
      <el-button v-preventReClick class="filter-item" type="primary" @click="submitPop('dialogForm')">{{ $t('button.Submit') }}</el-button>
    </div>
  </div>
</template>

<script>
import { mapActions, mapMutations } from 'vuex'
import { insert, update } from '@/api/company'
export default {
  props: ['companyPopInfo', 'popStatu', 'addCompanyPopShow'],
  data() {
    return {
      popObj: {
        companyParentName: null,
        companyParentId: null,
        companyName: null,
        companyAddr: null,
        companyUrl: null,
        id: null
      },
      userCompanyId: this.$store.state.companyId
    }
  },
  computed: {
    addCompanyRules() {
      return {
        companyName: [{ required: true, message: this.$t('lease.Cannotbeblanked'), trigger: 'blur' }]
      }
    }
  },
  watch: {
    companyPopInfo: {
      handler(newValue, oldValue) {
        for (var attr in newValue) this.popObj[attr] = newValue[attr]
      },
      deep: true,
      immediate: true
    },
    addCompanyPopShow(newVal) {
      if (newVal) {
        this.$nextTick(() => {
          this.$refs.dialogForm.clearValidate()// 移除表单项的校验结果
        })
      }
    }
  },
  created() { },
  methods: {
    closePop() { // 新增/编辑公司信息弹窗--关闭
      this.$emit('closePop')
    },
    submitPop(formName) { // 新增/编辑公司信息弹窗--提交
      console.log('this.popObj', this.popObj)
      this.$refs[formName].validate((valid) => {
        if (valid && !this.isShowMustIntWarn) {
          var param = JSON.parse(JSON.stringify(this.popObj))
          if (this.popStatu == 'add') {
            param.companyLevel = 2
            insert(param).then(res => {
              if (res.resultCode == 1001) {
                this.successFn()// 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
              } else {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
          } else if (this.popStatu == 'edit') {
            update(param).then(res => {
              if (res.resultCode == 1001) {
                this.successFn()// 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
              } else {
                this.$message({
                  type: 'error',
                  message: res.resultMessage
                })
              }
            })
          }
          console.log('param', param)
        }
      })
    },
    successFn() { // 弹窗提交成功后，调userInfoV3，并存储数据，刷新页面
      this.$message({
        message: this.$t('warningSet.submitted'),
        type: 'success'
      })
      this.$emit('closePop', 'needInt')
      // userInfoV3(this.getToken).then(res => {
      //   if (res.resultCode == 1001) {
      //     this.setUserInfo(res.resultModel)
      //     console.log(this.$store)
      //     this.$emit('closePop', 'needInt')
      //   }
      // })
    },
    change(e) {
      this.$forceUpdate()
    }
  }
}
</script>

<style lang="scss" scoped>
.addCompanyTem {
  margin: 0 auto;
  // font-size: 16px;
  .titleP {
    font-size: 14px;
    margin-bottom: 30px;
    text-align: center;
  }
  .btnWarp {
    margin-top: 30px;
  }
  .dialog-footer{
    text-align: center;
  }
}
</style>
